/* ==========================================================================
   IRON FIT - Showroom

   The three machines now live inside one composited photograph, so there is
   no per-bay background to align any more: the old floor-solver and panorama
   panning are gone. What is left is the interaction over the picture.

     hover / focus  -> the region lights up (CSS)
     click / Enter  -> that machine's page
     "Full specs"   -> slides the spec panel up inside its own region
   ========================================================================== */
(function () {
  'use strict';

  if (window.__ifzShowroom) return;
  window.__ifzShowroom = 1;

  function init() {
    var bays = [].slice.call(document.querySelectorAll('.mch'));
    if (!bays.length) return;

    function open(bay, on) {
      bays.forEach(function (b) {
        if (b !== bay) {
          b.classList.remove('is-open');
          b.setAttribute('aria-expanded', 'false');
        }
      });
      bay.classList.toggle('is-open', on);
      bay.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    function pageFor(bay) {
      var m = bay.className.match(/mch--(\w+)/);
      return window.IFZU('machine.html?m=' + (m ? m[1] : 'crossover'));
    }

    bays.forEach(function (bay) {
      bay.setAttribute('aria-expanded', 'false');

      var pill = bay.querySelector('.mch__turn');
      if (pill) {
        pill.addEventListener('click', function (e) {
          e.stopPropagation();
          open(bay, !bay.classList.contains('is-open'));
        });
      }

      /* Links inside the spec panel must not be swallowed by the region's
         own click handler. */
      var panel = bay.querySelector('.spec');
      if (panel) {
        panel.addEventListener('click', function (e) { e.stopPropagation(); });
      }

      bay.addEventListener('click', function () {
        /* An open panel closes on the first click, navigates on the next -
           keeps taps predictable on touch, where there is no hover-out. */
        if (bay.classList.contains('is-open')) { open(bay, false); return; }
        window.location.href = pageFor(bay);
      });

      bay.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        window.location.href = pageFor(bay);
      });

      bay.addEventListener('mouseleave', function () {
        bay.classList.remove('is-open');
        bay.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') bays.forEach(function (b) { open(b, false); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
